import { BsEye, BsEyeSlash } from "react-icons/bs";
import { employeeSignInUrl } from "../../api/endpoints";
import "./employeeAppLogin.css";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEmployee } from "../../slice/employeeSlice";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const EmployeeLogin = ({ signOut }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);

  const dispatch = useDispatch();

  useEffect(() => {
    // Check if both username and password are non-empty
    setIsFormValid(username.trim() !== "" && password.trim() !== "");
  }, [username, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isFormValid) {
      let payload = { employeeUsername: username, employeePassword: password };

      try {
        setIsLoading(true);
        let response = await fetch(employeeSignInUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (response.status === 404) {
          uiAlert("Invalid username or password. Please try again.", "error");
          return;
        }
        if (response.ok) {
          let { employee } = await response.json();
          console.log("Employee authenticated successfully:", employee);
          // check if returned employee belongs to the boss

          const isEmployeeByBoss = user.employees.some((emp) => emp.employeeID === employee._id);

          isEmployeeByBoss ? dispatch(setEmployee(employee)) : uiAlert("Credentials do not match any employee of this store.", "error");
          return;
        }
        throw new Error("Network response was not ok");
      } catch (error) {
        console.error("Error during employee authentication:", error);
        uiAlert("Authentication failed. Please try again.", "error");
      } finally {
        setIsLoading(false);
      }
    } else {
      // Optionally, you can show an error message or highlight the invalid fields
      uiAlert("Please fill in both fields.", "warning");
    }
  };

  return (
    <>
      <div class='pos-overlay' id='posEmployeeOverlay'>
        <div class='pos-modal'>
          <button
            onClick={() => {
              signOut();
            }}
            class='pos-modal-close'
            id='posModalClose'
          >
            &times;
          </button>

          <div class='pos-modal-header'>
            <div class='pos-modal-divider'></div>
            <h2 class='pos-modal-title'>Staff Authentication</h2>
            <p class='pos-modal-description'>Please verify your employee credentials to continue</p>
          </div>

          <form id='posEmployeeForm' class='pos-employee-form'>
            <div class='pos-input-group'>
              <label for='posEmployeeUsername' class='pos-input-label'>
                Staff Username
              </label>
              <div class='pos-input-wrapper'>
                <svg class='pos-input-icon' width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                  <circle cx='12' cy='7' r='4' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                </svg>
                <input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  type='text'
                  id='posEmployeeUsername'
                  class='pos-email-input'
                  placeholder='Enter employee username'
                  required
                />
              </div>
            </div>

            <div class='pos-input-group'>
              <label for='posEmployeePassword' class='pos-input-label'>
                Staff Password
              </label>
              <div class='pos-input-wrapper'>
                <svg class='pos-input-icon' width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <rect
                    x='3'
                    y='11'
                    width='18'
                    height='11'
                    rx='2'
                    ry='2'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path d='M7 11V7a5 5 0 0110 0v4' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
                </svg>
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? "text" : "password"}
                  id='posEmployeePassword'
                  class='pos-email-input'
                  placeholder='EME#25237790'
                  required
                />
                <span
                  class='pos-input-icon'
                  style={{ right: "15px", top: "50%", transform: "translateY(-50%)", left: "auto", display: "flex", alignItems: "center" }}
                >
                  {showPassword ? (
                    <BsEye style={{ cursor: "pointer" }} onClick={() => setShowPassword(false)} />
                  ) : (
                    <BsEyeSlash style={{ cursor: "pointer" }} onClick={() => setShowPassword(true)} />
                  )}
                </span>
              </div>
            </div>

            <button disabled={isLoading} onClick={handleSubmit} type='submit' class='pos-modal-button'>
              Verify & Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default EmployeeLogin;
